<template>
    <div class="page-setting has-bc biz-edit-emplyee-role-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <!-- <div class="btn-group">
                <button class="default-button publish" @click="saveData">儲存設定</button>
            </div> -->
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                職務部門資訊
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        職務部門
                        </div>
                        <div class="biz-table-content">
                            {{insertData.roleName?insertData.roleName:'-'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title auth-setting" slot="toogle-title">
                權限設定
                <div class="view-instruction">
                    <!-- <router-link :to="{ name: ''}" target="_blank">
                        <img src="@/assets/img/icon/view_gray.svg" alt="">
                        所有功能說明
                    </router-link> -->
                </div>
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row" v-for="(list,index) in insertData.authList" :key="index">
                        <div class="biz-table-title">
                            {{list.name}}
                        </div>
                        <div class="biz-table-content">
                            <span v-for="(subList,sIndex) in list.subModules" :key="sIndex">
                                <span v-for="(funcList,fIndex) in subList.functions" :key="fIndex">{{funcList.name}}、</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import ToogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import BlockGrey from '@/components/bussiness/widges/tools/blockGrey.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            componentKey: 0,
            authCategory: [],
            insertData: {
                roleId: '',
                roleName: '',
                authList: [],
            },
            error: {
                roleNameErr: '',
            },
        }
    },
    mounted () {
        // 取得詳細
        this.getInfo(this.$route.query.id)
        this.insertData.roleId = this.$route.query.id
    },
    watch: {
        'insertData.roleName' : {
            handler: function (newValue, oldValue) {
                if(newValue != ''){
                    this.error.roleNameErr = ''
                }else{
                    this.error.roleNameErr = '請填寫角色名稱'
                }
            },
            deep: true,
        },
        employeeRoleInfo: {
            handler: function (newValue, oldValue) {
                this.insertData.authList = this.employeeRoleInfo.authorityList
                this.insertData.roleName = this.employeeRoleInfo.roleName
            },
            deep: true,
        },
    },
    methods: {
        getInfo: function (id) {
            this.$store.dispatch('getBizEmployeeRoleInfo', id)
            .then(()=>{
                this.setMainCheckbox()
            })
        },
        checkInput: function () {
            if(this.insertData.roleName == ''){
                this.error.roleNameErr = '請填寫角色名稱'
                return false
            }else{
                return true
            }
        },
        // 編輯角色
        saveData: function () {
            if(this.checkInput()){
                this.$analyticsBiz.logEvent('編輯職務部門', { screen_name: '編輯職務部門'})
                this.$store.dispatch('editBizEmployeeRole', this.insertData)
                .then(res => {
                    if( res.data.status == "SUCCESS" ){
                        this.$router.push({ name: 'bizEmployeeRole'})
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
            }
        },
        changeAuthCheckbox: function (index) {
            this.authCategory[index] = true;
        },
        changeAuthSubAllCheckbox: function (index) {
            if(this.authCategory[index]){
                for(var i=0; i<this.insertData.authList[index].subModules.length; i++ ){
                    for(var j=0; j<this.insertData.authList[index].subModules[i].functions.length; j++ ){
                        this.insertData.authList[index].subModules[i].functions[j].right = false;
                    }
                }
            }else{
                for(var i=0; i<this.insertData.authList[index].subModules.length; i++ ){
                    for(var j=0; j<this.insertData.authList[index].subModules[i].functions.length; j++ ){
                        this.insertData.authList[index].subModules[i].functions[j].right = true;
                    }
                }
            }
        },
        setMainCheckbox: function () {
            let mainChk = this.employeeRoleInfo.authorityList
            for (let i = 0; i < mainChk.length; i++) {
                let subChk = mainChk[i].subModules
                for (let j = 0; j < subChk.length; j++) {
                    if(subChk[i]){
                        let funcChk = subChk[i].functions
                        for (let k = 0; k < funcChk.length; k++) {
                            if(this.authCategory[i] != true && funcChk[k].right){
                                this.changeAuthCheckbox(i)
                                this.componentKey += 1
                            }
                        }
                    }
                }
            }
            
        }
        
    },
    computed: {
        ...mapGetters({
            employeeRoleInfo : 'GET_BIZ_EMPLOYEE_ROLE_INFO',
        })
    },
    components: {
        ToogleBlock,
        BlockGrey,
        Checkbox,
    }
}
</script>
<style lang="scss">
    .biz-edit-emplyee-role-comp{
        margin-bottom: 230px;
        .must-fill-alarm{
            position: relative;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            color: #676362;
            padding: 0 24px;
            .star{
                color: #fc7171;
                margin: 0 2px;
            }
            img{
                margin-right: 2px;
            }
        }
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .biz-table{
            .biz-table-row{
                .biz-table-title{
                    width: 56px; 
                }
                .biz-table-content{
                    width: 902px; 
                    line-height: 1.5;
                }
            }
        }
        .auth-setting{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            .view-instruction, .view-instruction a {
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #676362;
            }
            .view-instruction {
                position: relative;
                right: 48px;
                a{
                    display: flex;
                    align-items: center;
                }
            }
        }
    }

    @media screen and (max-width: 1280px) {
     
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/employeeRole/viewEmployeeRoleComp.vue